<template>
    <div class="container w-100 d-flex justify-content-center flex-column px-4" style="max-width:none">
        <div class="d-flex justify-content-between py-4">
            <a-button @click="voltar" type="primary" :icon="h(ArrowLeftOutlined)" class="d-flex justify-content-center align-items-center">Voltar</a-button>
            <a-button @click="imprimir" type="primary" :icon="h(PrinterOutlined)" class="d-flex justify-content-center align-items-center">Imprimir</a-button>
        </div>
        <img src="/img/auto.png" class="img-fluid" alt="">

        <fieldset class="field-style">
            <legend class="field-style">Dados da vistoria</legend>
            <a-descriptions :column="3" class="mt-2">
                <a-descriptions-item label="ID" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosVistoria.id }}</a-descriptions-item>
                <a-descriptions-item label="Data da vistoria" :labelStyle="{ fontWeight: 'bold' }">{{ props.dadosVistoria.data }}</a-descriptions-item>
                <a-descriptions-item label="Número de protocolo" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosVistoria.protocolo ?? 'S/N' }}</a-descriptions-item>
                <a-descriptions-item label="Status" :labelStyle="{ fontWeight: 'bold' }">{{ formatStatus(props.dadosVistoria.status) }}</a-descriptions-item>
                <a-descriptions-item label="Observações" :labelStyle="{ fontWeight: 'bold' }">{{ props.dadosVistoria.observacoes ?? ' - ' }}</a-descriptions-item>
            </a-descriptions>
        </fieldset>

        <fieldset class="field-style">
            <legend class="field-style">Dados cadastrais do imóvel</legend>
            <a-descriptions :column="3" class="mt-2">
                <a-descriptions-item label="Inscrição Imobiliária" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosImovel.matricula }}</a-descriptions-item>
                <a-descriptions-item label="IDBQL" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosImovel.idbql }}</a-descriptions-item>
                <a-descriptions-item label="Setor" :labelStyle="{ fontWeight: 'bold' }">{{ props.dadosImovel.setor }}</a-descriptions-item>
                <a-descriptions-item label="Quadra" :labelStyle="{ fontWeight: 'bold' }">{{ props.dadosImovel.quadra }}</a-descriptions-item>
                <a-descriptions-item label="Lote" :labelStyle="{ fontWeight: 'bold' }">{{ props.dadosImovel.lote }}</a-descriptions-item>
                <a-descriptions-item label="Logradouro" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosImovel.rua }}</a-descriptions-item>
                <a-descriptions-item label="Número" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosImovel.numero || 'S/N' }}</a-descriptions-item>
                <a-descriptions-item label="Proprietário" :labelStyle="{ fontWeight: 'bold' }" :span="4">{{ props.dadosImovel.nome }}</a-descriptions-item>
            </a-descriptions>
        </fieldset>

        <fieldset class="field-style">
            <legend class="field-style">Lote</legend>
            <iframe height="420px" style="width:100%; border-radius:10px" class="embed-responsive-item" :src="`/func/not_planta?id=${props.dadosImovel.matricula}&type=lote`" allowfullscreen />
        </fieldset>

        <fieldset class="field-style">
            <legend class="field-style">Quadra</legend>
            <iframe height="420px" style="width:100%; border-radius:10px" class="embed-responsive-item" :src="`/func/not_planta?id=${props.dadosImovel.matricula}&type=quadra`" allowfullscreen />
        </fieldset>

        <fieldset class="field-style">
            <legend class="field-style">Vistoria do lote</legend>

            <a-descriptions :column="3" class="mt-2">
                <a-descriptions-item label="Área" :labelStyle="{ fontWeight: 'bold' }" :span="3">{{ props.dadosLote.area }}</a-descriptions-item>
                <a-descriptions-item label="Bairro" :labelStyle="{ fontWeight: 'bold' }" :span="3">{{ props.dadosLote.bairro }}</a-descriptions-item>
                <a-descriptions-item label="Zona Fiscal" :labelStyle="{ fontWeight: 'bold' }" :span="3">{{ props.dadosLote.zonaFiscal }}</a-descriptions-item>
            </a-descriptions>
            <fieldset class="field-style">
                <legend class="field-style">Características do lote</legend>
                <a-table
                    bordered
                    class="ant-table-striped"
                    :columns="columns"
                    :data-source="dataSource"
                    :pagination="pagination"
                    row-key="key"
                    size="small"
                    :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                >
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.dataIndex === 'descricao'">
                            <p>{{ record.key }} - {{ record.value.descricao }}</p>
                        </template>

                        <template v-if="column.dataIndex === 'opcoes'">
                            <div v-for="(opcao, index) in record.value.opcoes" :key="index" class="w-100 border d-flex">
                                <span class="d-flex px-2">{{ opcao.descricao }} ({{ opcao.pontuacao }})</span>
                                <br />
                            </div>
                        </template>

                        <template v-if="column.dataIndex === 'selected'">
                            <div v-for="(opcao, index) in record.value.opcoes" :key="index" class="w-100 border d-flex">
                                <span v-if="record.value.selected === opcao.codigo" class="w-100 text-center">X</span>
                                <br />
                            </div>
                        </template>
                    </template>
                    <template #footer>
                        <div style="text-align:right">
                            Soma de pontos: {{ dataSource.pontuacao }}
                        </div>
                    </template>
                </a-table>

                <div v-if="loaded">
                    <fieldset class="field-style">
                        <legend class="field-style">Imagens do lote</legend>
                        <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" v-if="subdivisionImages.length === 0">
                            <template #description>
                                Sem imagens
                            </template>
                        </a-empty>

                        <a-image v-for="imagem in subdivisionImages" width="50%" :src="imagem" class="p-3" />
                    </fieldset>
                </div>
            </fieldset>
        </fieldset>

        <div v-if="loaded">
            <template v-for="(construcao, index) in props.construcoes">
                <fieldset class="field-style" :style="{ opacity: props.dadosConstrucoes[index].baixa ? 0.6 : 1 }">
                    <legend class="field-style">
                        Vistoria unidade nº {{ index + 1 }}
                        <span v-if="construcao.baixa" style="color:red">(BAIXADA)</span>
                    </legend>

                    <a-descriptions :column="4" class="mt-2">
                        <a-descriptions-item label="Código da rua" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].codigoRua }}</a-descriptions-item>
                        <a-descriptions-item label="Logradouro" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].logradouro }}</a-descriptions-item>
                        <a-descriptions-item label="Número" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].numero }}</a-descriptions-item>
                        <a-descriptions-item label="Complemento" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].complemento ?? ' - ' }}</a-descriptions-item>
                        <a-descriptions-item label="Ano da construção" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].dataConstrucao }}</a-descriptions-item>
                        <a-descriptions-item label="Data de lançamento" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].dataLancamento ?? 'S/D' }}</a-descriptions-item>
                        <a-descriptions-item label="Data do Habite-se" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].dataHabitese ?? 'S/D' }}</a-descriptions-item>
                        <a-descriptions-item label="Área da construção" :labelStyle="{ fontWeight: 'bold' }":span="2">{{ props.dadosConstrucoes[index].areaConstrucao }}</a-descriptions-item>
                        <a-descriptions-item label="Pavimentos" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].pavimentos ?? ' - ' }}</a-descriptions-item>
                        <a-descriptions-item label="Construção Principal" :labelStyle="{ fontWeight: 'bold' }" :span="2">{{ props.dadosConstrucoes[index].construcaoPrincipal ? 'Sim' : 'Não' }}</a-descriptions-item>
                        <a-descriptions-item label="Observações" :labelStyle="{ fontWeight: 'bold' }" :span="3">{{ props.dadosConstrucoes[index].observacoes ?? ' - ' }}</a-descriptions-item>
                    </a-descriptions>
                    <fieldset class="field-style" :style="{ opacity: construcao.baixa ? 0.6 : 1 }">
                        <legend class="field-style">Características unidade nº {{ index + 1 }}</legend>
                        <a-table
                            bordered
                            class="ant-table-striped"
                            :columns="columns"
                            :data-source="Object.values(construcao)"
                            :pagination="pagination"
                            row-key="key"
                            size="small"
                            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                        >
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.dataIndex === 'descricao'">
                                    <p>{{ record.codigo }} - {{ record.descricao }}</p>
                                </template>

                                <template v-if="column.dataIndex === 'opcoes'">
                                    <div v-for="(opcao, index) in record.opcoes" :key="index" class="w-100 border d-flex">
                                        <span class="d-flex px-2">{{ opcao.descricao }} ({{ opcao.pontuacao }})</span>
                                        <br />
                                    </div>
                                </template>

                                <template v-if="column.dataIndex === 'selected'">
                                    <div v-for="(opcao, index) in record.opcoes" :key="index" class="w-100 border d-flex">
                                        <span v-if="record.selected === opcao.codigo" class="w-100 text-center">X</span>
                                        <br />
                                    </div>
                                </template>
                            </template>
                            <template #footer>
                                <div style="text-align:right">
                                    Soma de pontos: {{ construcao.pontuacao }}
                                </div>
                            </template>
                        </a-table>

                        <fieldset class="field-style" :style="{ opacity: construcao.baixa ? 0.6 : 1 }">
                            <legend class="field-style">
                                Imagens da construção {{ index + 1 }}
                                <span v-if="construcao.baixa" style="color:red">(BAIXADA)</span>
                            </legend>
                            <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" v-if="buildingsImages[index].length === 0">
                                <template #description>
                                    Sem imagens
                                </template>
                            </a-empty>

                            <a-image v-for="imagem in buildingsImages[index]" width="50%" :src="imagem" class="p-3" />
                        </fieldset>
                    </fieldset>
                </fieldset>
            </template>
        </div>
    </div>
</template>

<script setup>
import {onMounted, h, ref, nextTick} from "vue";
import {ArrowLeftOutlined, PrinterOutlined} from "@ant-design/icons-vue";
import axios from "axios";
import {Empty} from "ant-design-vue";

const props = defineProps(['dadosVistoria', 'dadosImovel', 'dadosLote', 'caracteristicasLote', 'dadosConstrucoes', 'construcoes'])
const pagination = ref({ pageSize: 10 });
const vistoriaId = new URLSearchParams(window.location.search).get('id')
const subdivisionImages = ref([])
const buildingsImages = ref([])
const loaded = ref(false)
const dataSource = Object.entries(props.caracteristicasLote).map(([key, value]) => ({ key, value }))
const columns = [
    {
        title: 'Grupos/Partes do Prédio',
        width: 100,
        dataIndex: 'descricao',
        key: 'descricao',
    },
    {
        title: 'Características construtivas',
        width: 150,
        dataIndex: 'opcoes',
        key: 'opcoes',
        className: 'no-padding-cell',
    },
    {
        title: 'Selec.',
        width: 30,
        dataIndex: 'selected',
        key: 'selected',
        className: 'no-padding-cell',
    }
];

const voltar = () => window.history.back();
const imprimir = async () => {
    pagination.value = false;
    await nextTick();
    window.print();
}

const mountPontuacoes = () => {
    dataSource.pontuacao = 0;
    dataSource.forEach(item => {
        let pontuacao = 0
        Object.entries(item.value.opcoes).forEach(([key, value]) => {
            if (item.value.selected !== null && item.value.selected === value.codigo ) {
                pontuacao += value.pontuacao;
            }
        })

        dataSource.pontuacao += pontuacao;
    })

    props.construcoes.forEach(construcao => {
        let pontuacao = 0
        Object.entries(construcao).forEach(([key, value]) => {
            if (typeof value === 'object' && value.selected !== null && value.opcoes[value.selected]) {
                pontuacao += value.opcoes[value.selected].pontuacao;
            }
        });

        construcao.pontuacao = pontuacao;
    })
}

const handleAfterPrint = () => {
    pagination.value = { pageSize: 10 };
};

onMounted(async () => {
    mountPontuacoes();
    const response = (await window.axios.get(`/api/inspections/images/${vistoriaId}`)).data.data
    subdivisionImages.value = response.subdivisionImages
    buildingsImages.value = response.buildingsImages

    loaded.value = true
    window.addEventListener('afterprint', handleAfterPrint);
})

const formatStatus = (status) => {
    switch (status) {
        case 'canceled' : return 'Cancelado'
        case 'inProgress': return 'Em andamento'
        case 'completed' : return 'Completado'
        case 'migratedData' : return 'Dados migrados'
    }
}
</script>

<style scoped>
fieldset.field-style {
    border: 1px groove #ddd !important;
    border-radius: 10px !important;
    padding: 0 1.4em 1.4em 1.4em !important;
    margin: 0 0 1.5em 0 !important;

    -webkit-box-shadow: 0px 0px 0px 0px #000;
    box-shadow: 0px 0px 0px 0px #000;
}

legend.field-style {
    font-size: 1.2em !important;
    float: inherit !important;
    font-weight: bold !important;
    text-align: left !important;
    width: auto;
    padding: 0 10px;
    border-bottom: none;
}

.ant-table-striped :deep(.table-striped) td {
    background-color: #fafafa;
}

:deep(.no-padding-cell) {
    padding: 0 !important;
}
</style>